var v1="<div gnp-score-analysis=\"\" score-data=\"saCtrl.scoreData\"></div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("analysis/score-analysis/score-analysis.jade", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ngapp/javascript/web/analysis/score-analysis/score-analysis.jade
// module id = 460
// module chunks = 0